/**
 * ds-proof-cta-slider.js
 * Lightweight media slider for the Social Proof CTA section.
 * Supports images, Shopify-hosted videos, and external embeds (YouTube/Vimeo).
 * Multiple instances on the same page are handled independently.
 */
(function () {
  'use strict';

  /**
   * Convert a watch URL to an embeddable iframe URL.
   * Passes through URLs that are already embed-formatted.
   */
  function toEmbedUrl(rawUrl) {
    var ytMatch = rawUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    if (ytMatch) {
      return 'https://www.youtube.com/embed/' + ytMatch[1] + '?rel=0&modestbranding=1';
    }

    var vimeoMatch = rawUrl.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) {
      return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?dnt=1';
    }

    return rawUrl;
  }

  /**
   * Build and inject iframes for all external-video placeholders inside a container.
   */
  function buildIframes(container) {
    var wrappers = container.querySelectorAll('.proof-cta__slide-iframe-wrap[data-video-url]');
    wrappers.forEach(function (wrap) {
      var rawUrl = wrap.getAttribute('data-video-url');
      if (!rawUrl) return;

      var iframe = document.createElement('iframe');
      iframe.src = toEmbedUrl(rawUrl);
      iframe.className = 'proof-cta__slide-iframe';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('loading', 'lazy');

      wrap.appendChild(iframe);
      wrap.removeAttribute('data-video-url');
    });
  }

  /**
   * Initialise a single slider element.
   */
  function initSlider(sliderEl) {
    var slidesWrap = sliderEl.querySelector('.proof-cta__slides');
    var slides = Array.from(sliderEl.querySelectorAll('.proof-cta__slide'));
    var dots = Array.from(sliderEl.querySelectorAll('.proof-cta__dot'));
    var prevBtn = sliderEl.querySelector('.proof-cta__arrow--prev');
    var nextBtn = sliderEl.querySelector('.proof-cta__arrow--next');

    // Always build iframes regardless of slide count
    buildIframes(sliderEl);

    // Single slide — no navigation needed
    if (slides.length < 2) return;

    var autoplay = sliderEl.getAttribute('data-autoplay') === 'true';
    var delay = parseInt(sliderEl.getAttribute('data-delay'), 10) || 4000;
    var currentIndex = 0;
    var autoplayTimer = null;

    function goTo(index) {
      currentIndex = (index + slides.length) % slides.length;
      slidesWrap.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

      // Update dot states
      dots.forEach(function (dot, i) {
        dot.classList.toggle('proof-cta__dot--active', i === currentIndex);
      });

      // Manage video playback — play active slide's video, pause others
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === currentIndex) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function startAutoplay() {
      if (!autoplay) return;
      autoplayTimer = setInterval(function () {
        goTo(currentIndex + 1);
      }, delay);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(currentIndex + 1);
        startAutoplay();
      });
    }

    // Dot navigation
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(i);
        startAutoplay();
      });
    });

    // Touch swipe (horizontal)
    var touchStartX = 0;
    sliderEl.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    sliderEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var SWIPE_THRESHOLD = 40;
      if (Math.abs(dx) > SWIPE_THRESHOLD) {
        stopAutoplay();
        goTo(currentIndex + (dx < 0 ? 1 : -1));
        startAutoplay();
      }
    });

    // Pause autoplay on hover
    sliderEl.addEventListener('mouseenter', stopAutoplay);
    sliderEl.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.proof-cta__slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
